import router from '@/router';
function routeRequiresAuth(route) {
    return route.matched.some((x) => x.meta.requiresAuth);
}
const actions = {
    async init({ dispatch, commit }) {
        commit('setState', 'stores.nav.loadingPage');
        router.beforeEach((to, current, next) => dispatch('beforeNavHook', { to, current, next }));
        router.afterEach((route) => dispatch('afterNavHook', route));
        // will never fail, just wait
        await dispatch('onRouterReady');
        dispatch('beforeNavHook', {
            to: router.currentRoute,
            current: router.currentRoute,
            next: (to) => {
                if (to) {
                    commit('setState', 'stores.nav.loadingPage', to.name);
                    router.push(to); // nav to, after nav will stop loading
                }
                else
                    commit('clearState'); // already at route, stop loading
            }
        });
    },
    onRouterReady() {
        return new Promise((resolve) => {
            // if (router.history.current.name){
            if (router.currentRoute.name) {
                return resolve();
            }
            router.onReady(() => resolve());
        });
    },
    beforeNavHook({ dispatch, commit }, { to, current, next }) {
        commit('setState', 'stores.nav.loadingPage', to.name);
        // if authenticated, dont go to login
        if (this.getters['auth/authenticated'] && to.name == 'login')
            return next('/');
        // anon routes or authenticated routes continue if authenticated
        if (this.getters['auth/authenticated'] || !routeRequiresAuth(to))
            return next();
        // requires auth, but not authenticated and request login page, continue
        if (to.name == 'login')
            return next();
        // deafault, redirect to login
        return next('/login');
    },
    // // setup after hooks to ensure initializing is false
    afterNavHook({ dispatch, commit }, route) {
        // if(!routeRequiresAuth(route) || this.getters['auth/authenticated'])
        commit('clearState');
    }
};
export default actions;
